import tinymce from "tinymce";

import "tinymce/icons/default";
import "tinymce/themes/silver";

// Import plugins as needed
import "tinymce/plugins/advlist";
import "tinymce/plugins/anchor";
import "tinymce/plugins/autolink";
import "tinymce/plugins/charmap";
import "tinymce/plugins/code";
import "tinymce/plugins/emoticons";
import "tinymce/plugins/fullscreen";
import "tinymce/plugins/help";
import "tinymce/plugins/hr";
import "tinymce/plugins/image";
import "tinymce/plugins/imagetools";
import "tinymce/plugins/insertdatetime";
import "tinymce/plugins/link";
import "tinymce/plugins/lists";
import "tinymce/plugins/media";
import "tinymce/plugins/nonbreaking";
import "tinymce/plugins/paste";
import "tinymce/plugins/preview";
import "tinymce/plugins/print";
import "tinymce/plugins/quickbars";
import "tinymce/plugins/searchreplace";
import "tinymce/plugins/table";
import "tinymce/plugins/template";
import "tinymce/plugins/textpattern";
import "tinymce/plugins/visualblocks";
import "tinymce/plugins/visualchars";
import "tinymce/plugins/wordcount";

import imageUploadHandler from "../../tinymce_file_upload_handlers/image_uploads";

const initEditor = async (lv) => {
  const emojis = await import("tinymce/plugins/emoticons/js/emojis");

  tinymce.init({
    target: lv.querySelector("textarea"),
    content_css: "/vendor/tinymce/content/default/content.css",
    contextmenu: "image link table",
    deprecation_warnings: false,
    emoticons_database_url: emojis,
    help_tabs: ["shortcuts", "keyboardnav"],
    images_upload_handler: imageUploadHandler,
    image_advtab: true,
    min_height: 500,
    paste_data_images: false,
    plugins: [
      "advlist anchor autolink charmap code emoticons fullscreen help hr image imagetools insertdatetime link lists media paste preview print quickbars searchreplace table textpattern visualblocks visualchars wordcount",
    ],
    quickbars_insert_toolbar: false,
    removed_menuitems: "newdocument, restoredraft, visualaid",
    skin_url: "/vendor/tinymce/skins/ui/oxide",
    toolbar1:
      "styleselect fontselect fontsizeselect | bold italic strikethrough forecolor backcolor",
    toolbar2:
      "alignleft aligncenter alignright alignjustify | link image table | bullist numlist outdent indent | media emoticons | removeformat fullscreen",
  });
};

export default {
  GroupWebsiteEditorWysiwygEditor: {
    mounted() {
      // Save the file upload request URL so we can use it in the upload handlers
      const { fileUploadRequestUrl } = this.el.dataset;
      window.fileUploadRequestUrl = fileUploadRequestUrl;

      initEditor(this.el);
    },
    destroyed() {
      // Remove TinyMCE instance when we leave so it can be re-initialized when we visit again
      // If we don't do this, TinyMCE won't show if we open another Page for editing since
      // a previous instance would already exist
      tinymce.remove();
    },
  },
};
